<template>
    <div>
        <div class="content preview">
            <nav class="sum">
                {{ $t('prediction')}}
                <template v-if="voteData.total_num">{{ $tc('voteNum', 10, {count: voteData.total_num}) }}</template>
            </nav>
            <div class="container">
                <p class="forecast" v-if="voteData.name&&isShowOverview">{{voteData.name}}</p>
                <ul class="vote_con">
                    <li v-for="item in voteData.data" :key="item.id">
                        <div class="vote_view" :id="item.name.toLowerCase()" data-vote="1">
                            <div class="vote_box">
                                <div class="progress_con">
                                    <div class="progress" :style="{'height': height(item.num) + 'px', 'line-height': height(item.num) + 'px'}">
                                        <b>{{item.percent}}%</b>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom_vote" :class="{'clicked': !votable(item.id) || voted(item.id)}" @click.prevent="vote(item.id)">
                                <span></span> {{voted(item.id) ? $t('voted') : $t('vote')}}
                            </div>
                            <p>
                                <img v-if="item.id === 1" alt="" :src="getImgSrc(homeImgSrc)">
                                <img v-if="item.id === 3" alt="" :src="getImgSrc(awayImgSrc)">
                                <span>{{$t(item.name.toLowerCase())}}</span>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <past-games v-if="analysisData" :game-data="analysisData"></past-games>
            <skeleton v-else></skeleton>
            <div id="mask" style="display: none">
                <span>{{$t('matchNotStart')}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    // import Vue from 'vue';
    import Fingerprint from 'fingerprintjs';
    import PastGames from './pastGames.vue';
    import Skeleton from './skeleton.vue';
    // import browers from '../util/browers';
    import axios from 'axios';

    // // 兼容老版本，避免sentry报错
    // window.videoIsPlaying = function () {
    //     return false;
    // };

    export default {
        data () {
            return {
                isShowOverview: false, // !Boolean(this.$query['locale']) &&  // 非多语言测试版
                //     (browers.iOS && browers.version >= 220) || (browers.Android && browers.version >= 47 && browers.version != 49), // ios版本大于220，android版本大于47
                tabShow: 'preview',
                voteData: {
                    data: [
                        {id: 1, name: 'Home', num: 0, percent: 0},
                        {id: 2, name: 'Draw', num: 0, percent: 0},
                        {id: 3, name: 'Away', num: 0, percent: 0}
                    ],
                    total_num: 0,
                    select_opt: []
                },
                analysisData: null,
                animateFinished: false, // 某些机型下的bug
                elAnalysisHtml: '',
                elOverviewHtml: '',
                homeImgSrc: '',
                awayImgSrc: '',
                UUID: ''
            };
        },
        props: ['matchId'],
        components: {
            PastGames,
            Skeleton
        },
        computed: {
            matchAnalysisFormation () {
                return this.$store.state.matchDetailStore.matchAnalysisFormation;
            }
        },
        created () {
            this.homeImgSrc = this.matchAnalysisFormation.team_A_logo || '';
            this.awayImgSrc = this.matchAnalysisFormation.team_B_logo || '';
            this.analysisData = this.matchAnalysisFormation || null;
        },
        mounted () {
            // 生成UUID
            this.UUID = 'CA' + new Fingerprint({canvas: true}).get();
            axios.get(`/v2/vote/result/match/${this.matchId}`, {
                headers: {
                    uuid: this.UUID
                },
                params: {
                    language: this.$i18n.local
                }
            }).then(res => {
                const data = res.data;
                if (data.errCode === 0) {
                    this.voteData = data.data;
                    this.votePercent(this.voteData);
                }
            }).catch(() => {
                console.log('出错了');
            });
        },
        watch: {
            // hack
            elOverviewHtml () {
                this.resizeIframeHeight();
            }
        },
        methods: {
            votePercent (voteData) {
                // 百分比取整，需要满足和为100，比较蛋疼
                const percents = [];
                let offsetPercent = 0;

                voteData.data.forEach(item => {
                    let per = voteData.total_num ? (item.num / voteData.total_num) * 100 : 0;
                    item.percent = Math.round(per);
                    offsetPercent += item.percent;

                    percents.push(per - Math.floor(per));
                });
                if (!offsetPercent) {
                    return;
                }
                if (offsetPercent > 100) {
                    let i = percents.indexOf(Math.min.apply(null, percents)); // 最小的数做补偿
                    voteData.data[i].percent -= 1;
                } else if (offsetPercent < 100) {
                    let i = percents.indexOf(Math.max.apply(null, percents)); // 最大的数做补偿
                    voteData.data[i].percent += 1;
                }
            },
            height (num) {
                if (!this.voteData.total_num) {
                    return 20;
                }
                return Math.floor((num / this.voteData.total_num) * 52 + 20);
            },

            votable () {
                if (this.isMatchStart()) {
                    return false;
                }
                if (this.voteData.select_opt && this.voteData.select_opt.length) {
                    return false;
                }

                return true;
            },

            voted (id) {
                if (this.voteData.select_opt &&
                    this.voteData.select_opt.some(item => {
                        return +item === id;
                    })) {
                    return true;
                }
                return false;
            },

            vote (id) {
                if (this.votable() && !this.voted(id)) {
                    axios.get(`/v2/vote/match/${this.matchId}?match_id=${this.matchId}&opt_id=${id}`, {
                        headers: {
                            uuid: this.UUID
                        },
                        params: {
                            language: this.$i18n.local
                        }
                    }).then(res => {
                        if (res.status !== 200) {
                            return;
                        }
                        const data = res.data;
                        if (!data.errCode) {
                            this.voteData.select_opt.push(id);
                            this.voteData.data[id - 1].num ++;
                            this.voteData.total_num ++;
                            this.votePercent(this.voteData);
                        }
                    });
                }
            },
            resizeIframeHeight () {
                let frame = document.getElementById('overviewFrame');
                if (!this.elOverviewHtml || !frame) {
                    return;
                }

                let iframeDoc = frame.contentDocument || frame.contentWindow.document;

                iframeDoc.open();
                iframeDoc.write(this.elOverviewHtml);
                iframeDoc.close();

                frame.style.height = iframeDoc.body.scrollHeight + 'px';
                // if (window.Android && window.Android.resetHeight) {
                //     window.Android.resetHeight(document.body.scrollHeight);
                // }
            },
            isMatchStart () {
                const voteData = this.voteData;
                if (voteData && voteData.start_time) {
                    let date = new Date(voteData.start_time.replace(/-/g, '/')).getTime();
                    let diffMin = new Date().getTimezoneOffset();
                    date = date - diffMin * 60 * 1000;
                    let nowDate = new Date().getTime();

                    return nowDate >= date;
                }
                return true;
            }
        }
    };
</script>
<style scoped>
    a {
        color: #000;
    }

    html,
    body {
        height: 100%;
    }

    body {
        /*设置英文字体*/
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        background: #eff1f4;
    }
    p,
    div,
    ul,
    ol,
    li{
        margin: 0;
        padding: 0;
    }
    body {
        margin: 0;
        padding: 0;
        font-size: 12px;
        -webkit-font-smoothing: antialiased;
        position: relative;
    }
    nav {
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        font-weight: 700;
        color: #333;
        background: #e2e4e6;
        text-align: left;
        padding-left: 16px;
    }

    nav a {
        font-size: 12px;
        float: right;
        margin-right: 5px;
        color: #16ac3a;
        text-decoration: none;
    }

    .container {
        position: relative;
    }

    .forecast {
        top: 5px;
        text-align: center;
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin-bottom: -15px;
        background: #eff1f4;
        padding-top: 5px;
        margin-top: 0;
    }
    /*预测样式*/

    ul.vote_con {
        margin: 0;
        height: 120px;
        padding: 15px 10%;
        background: #eff1f4;
        list-style: none;
    }

    ul.vote_con li {
        width: 33.3333333333%;
        float: left;
        position: relative;
    }

    ul.vote_con li:first-child {
        left: -3%;
    }

    ul.vote_con li:last-child {
        right: -3%;
    }

    ul .vote_view {
        position: relative;
        width: 86%;
        height: 112px;
        margin: 0 auto;
    }

    ul .vote_view .bottom_vote {
        text-align: center;
        color: #fff;
        position: relative;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        width: 100%;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    ul .vote_view p {
        color: #999999;
        text-align: center;
        width: 100%;
        margin: 0;
        font-size: 12px;
        height: 35px;
        line-height: 35px;
        white-space: nowrap;
    }

    ul .vote_view p img {
        position: relative;
        bottom: 1px;
        height: 16px;
        width: 16px;
        vertical-align: middle;
    }

    ul .vote_view b {
        display: block;
        font-size: 16px;
        color: #fff;
    }

    ul .bottom_vote span {
        display: inline-block;
        margin-right: 4px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDMkI5M0YzRUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDMkI5M0Y0RUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjFFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjJFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZbxI3AAAA+klEQVR42mL8//8/AwnAAIi9gHglEN8lSgfIAhLwjv8Q8AmII4nRQ4rhrED85D8qsCWkj4mE4JEDYkE0sU5CmkixQAmIudDELIFYlVoW4DJIhloWmGBLI0D8gxoWgILGB4v4FyB+SA0L+oBYFIv4dSB+hk8jC5RWB2JWHCknCYiDcej/A8RaOBz6G4hvgtJq+X/agXJGIPEVS/KjFvgB8to/BtqB00zQsKIV2MzEQFtwgJYW3Abic7S04CAQ/6WlBRtJLYtIAR+A+BgtLQAFzztaWrAXubBjo7Lh/9Et+ENlCx4A8TXk0jQDiPuBmJ0Khn8C4kxkAYAAAwC3wR7EkrY5PgAAAABJRU5ErkJggg==);
        background-position: center center;
        background-size: 12px 12px;
        background-repeat: no-repeat;
        height: 12px;
        width: 12px;
        vertical-align: middle;
        position: relative;
        bottom: 1px;
    }

    ul .bottom_vote span.voted {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgwRkYzQkNDRUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgwRkYzQkNERUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjVFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjZFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4U4m8kAAAA6klEQVR42rSWywrCMBBF07QKWhUVRNy4EkXdufL/P0EXfoHShRXF+gC19Q5EKcGqgZkLh5ahySEhGeplWaYc0gBdsAGnfwZ4joI56IA7WID1rwHaYXL6tm7eAzADbU5BBZSs2oRTUAW+VWuBkEsQflkZi6BZUH9wCHxzPO3QabpwCKag/KGegOu3gYF51uhOFOxvH/QKxqe5o2uHLlhCF22Al7GSyYq2aKjkMtJmKVLZSwsirWQTSwqonR8kBTFtv6Qgcu1FLrmBnaQgNhIxwTbf7LS0IGWe/AyO+W66NO2YYyWvv413ngIMAJZ8LcWM3z54AAAAAElFTkSuQmCC);
    }

    ul .vote_view .vote_box {
        position: relative;
        left: 0;
        height: 72px;
        width: 100%;
        -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
        overflow: hidden;
    }

    #away .progress {
        background: #f12b2b;
    }

    #away .bottom_vote {
        background: #cd2525;
    }

    #away .clicked {
        color: #dc6767;
    }

    #home .progress {
        background: #49c867;
    }

    #home .bottom_vote {
        background: #3eaa58;
    }

    #home .clicked {
        color: #78c48a;
    }

    #draw .progress {
        background: #1d9ff9;
    }

    #draw .bottom_vote {
        background: #1987d4;
    }

    #draw .clicked {
        color: #5eabe1;
    }

    .progress_con {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .progress {
        position: absolute;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        bottom: 0;
        width: 100%;
        height: 20px;
        line-height: 20px;
        z-index: 1;
        text-align: center;
        color: #151515;
        font-weight: bold;
        -webkit-transition: background 250ms ease;
        transition: background 250ms ease;
    }

    .content.preview {
        background: #eff1f4;
        margin: 0;
    }

    .content iframe {
        width: 100%;
        border: none;
        margin: 0;
    }

    .content.overview p {
        background: #eff1f4;
        margin: 0;
        width: 100%;
        position: absolute;
        bottom: 0;
        top: 50px;
        font-size: 14px;
        line-height: 220px;
        color: #999;
        text-align: center;
    }

    #mask {
        position: fixed;
        margin: auto;
        top: 180px;
        left: 0;
        right: 0;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }

    #mask span {
        font-size: 14px;
        padding: 10px 16px;
        text-align: center;
        line-height: 25px;
        border-radius: 4px;
        color: #fff;
        background-color: #383a3c;
        display: inline-block;
        max-width: 67%;
    }

    /*未知模块*/
    input {
        border: 0;
        margin: 0;
        padding: 0;
        width: 0;
        height: 0;
    }

    nav.tab {
        text-align: center;
        display: block;
        width: 100%;
        background: #eff1f4;
        height: auto;
        padding: 16px 0;
        line-height: 0;
    }

    nav.tab ul {
        display: inline-block;
        border: 1px solid #16ac3a;
        /*no*/
        font-size: 14px;
        border-radius: 2px;
        width: 64%;
        font-size: 0;
        list-style: none;
        padding: 0;
        height: 28px;
    }

    nav.tab li {
        list-style: none;
        display: inline-block;
        width: 50%;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        color: #16ac3a;
    }

    nav.tab li a {
        display: block;
        color: inherit;
        font-size: inherit;
        text-align: inherit;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    nav.tab li.current {
        background: #16ac3a;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// matchAnalysis.vue?c6bfe288